// extracted by mini-css-extract-plugin
export var orderSummary = "_no-0";
export var showMoreLessButton = "_no-1";